import { DefaultFilter } from './../framework/default-service.interface';
import { Component, OnInit, Input, OnDestroy, ViewChild, ElementRef, AfterViewInit, ChangeDetectorRef, AfterViewChecked } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Subscription, Observable, fromEvent, Subject } from 'rxjs';
import { map, debounceTime, distinctUntilChanged, catchError } from 'rxjs/operators';
import { LazyLoadEvent } from 'primeng/api';

import { ILista } from './lista.interface';
import { DefaultService } from './../framework/default-service';
import { ListHandlerService } from './list-handler.service';
import { Lista } from './lista.model';
import { ToasterService } from '../framework/toaster/toaster.service';
import { PopoverInputComponent } from '../framework/popover-input/popover-input.component';
import { ListaUtil } from './lista-util';
import { ListaResultset } from './lista-resultset.interface';
import { Metadata } from './metadata/metadata.component';
import { environment } from 'src/environments/environment';
import { IListaBundle } from './lista-bundle.interface';
import { ResultsetPipeUtil } from '../framework/pipes/resultset-pipe.util';
import { DomSanitizer } from '@angular/platform-browser';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { DataType } from '../enums/datatype.enum';


@Component({
  selector: 'app-lista',
  templateUrl: './lista.component.html',
  styleUrls: ['./lista.component.css']
})
export class ListaComponent implements OnInit, OnDestroy, AfterViewInit, AfterViewChecked {

  private debug = false;

  private carregarListagemSubject = new Subject<Lista>();
  @ViewChild('poi') public poi: PopoverInputComponent;

  // Se esta variável for FALSE, significa que este componente nao deve alterar o menu/breadcrumb
  @Input() exibirLegenda = true;
  // @Input() pConfigurarMenuConfig = false;
  @Input() tipoLista: string;
  @Input() controller: ILista;
  @Input() pAoSelecionarLinha: Function;
  @Input() pCarregarListagem: Function;
  @Input() noServiceAndObservable: boolean;
  @Input() esconderBotaoExcel: boolean = true;
  @Input() esconderPaginacao: boolean;
  @Input() esconderCabecalho: boolean = false;
  @Input() carregarOnLoad = true;

  refreshHackFix = true;

  subscriptionListRefresh: Subscription;
  subscriptionParam: Subscription;

  private context: ListaComponent = this;
  private listaUtil: ListaUtil = null;
  private resultsetPipeUtil: ResultsetPipeUtil = null;

  lista: Lista;
  totalRegistros = null;
  size = 0;
  loading: boolean = false;
  filter: DefaultFilter;
  hasError = false;
  errorMsg = '';
  // Parâmetro tipo JSON recebido via QueryParam ( encodificado base64 )
  param: any;

  @ViewChild('inputBuscaRapida') inputBuscaRapida: ElementRef;
  metadataBuscaRapida: Metadata = null;
  buscaRapidaNomePlaceholder = '';
  private subscriptionBuscaRapida: Subscription;

  private filterControllerAntigo: DefaultFilter;

  public _checkboxDataType = DataType.CHECKBOX;
  public _buttonDataType   = DataType.BUTTON;

  acumuladores = {};

  private paginaIniciando: boolean = true;

  constructor(
      private route: ActivatedRoute
      , private router: Router
      , public toasterService: ToasterService
      , private listHandlerService: ListHandlerService
      , private changeDetectorRef: ChangeDetectorRef
      , private datePipe: DatePipe
      , private domSanitizer: DomSanitizer
      , private currencyPipe: CurrencyPipe
  ) {
      this.lista = {
          idLista: this.tipoLista
          , resultset: null
          , cols: []
      };

      this.listaUtil = new ListaUtil();
      this.resultsetPipeUtil = new ResultsetPipeUtil(this.datePipe, this.domSanitizer, this.currencyPipe);
      this.filter = this.listaUtil.criaDefaultFilter();

      this.subscriptionListRefresh = this.listHandlerService.listRefresh$.subscribe(listHandlerParam => {

          if (listHandlerParam && listHandlerParam.lista) {

                  this.lista = listHandlerParam.lista;
                  // hack para forçar o refresh da PrimeNg TurboTable ( aparentemente um bug no componente )
                  this.recarregarListagemHack();
                  setTimeout(() => {
                    this.loading = false;
                  }, 0);
                  // caso tenha sido passado os dados da lista, nada mais deve ser executado
          }
          else if (listHandlerParam && listHandlerParam.tipo && (listHandlerParam.tipo === 'EXIBIR_CARREGANDO'   ||
                                                                 listHandlerParam.tipo === 'ESCONDER_CARREGANDO' ||
                                                                 listHandlerParam.tipo === 'ERRO' )) {
            if (listHandlerParam.tipo === 'ERRO') {
              setTimeout(() => {
                this.loading = false;
                this.hasError = true;
              }, 0);
            }
            else if (listHandlerParam.tipo === 'EXIBIR_CARREGANDO') {
              setTimeout(() => {
                this.loading = true;
              }, 0);
            }
            else {
              setTimeout(() => {
                this.loading = false;
              }, 0);
            }
          }
          else {
              this.loading = false;

              if (listHandlerParam) {
                  if (listHandlerParam.filtro) {
                      this.filter = listHandlerParam.filtro;
                  }
                  if (listHandlerParam.tipo) {
                      this.tipoLista = listHandlerParam.tipo;
                  }
              }
              if (this.pCarregarListagem) {
                  this.pCarregarListagem();
              }
              else {
                  this.carregarListagem('subscriptionListRefresh');
              }
          }

      });

      this.subscriptionParam = this.route.params.subscribe(params => {
          // console.log('list: this.route.params.subscribe: params: ' + JSON.stringify(params));
          // objeto genérico que pode ser passado p/ a lista.
          if (params['param']) {
              this.param = JSON.parse(atob(params['param']));
          }
      });
  }


  ngAfterViewChecked() {
    this.changeDetectorRef.detectChanges();
  }

  ngOnInit() {
    if ( this.debug ) { console.log('lista.component : ngOnInit'); }

    this.paginaIniciando = true;

    if ( this.carregarOnLoad ) {
      if ( this.controller && this.controller.getFilter ) {
        this.filter = this.controller.getFilter();
      }

      if (this.controller && this.controller.getMetadata) {
        this.lista.cols = this.controller.getMetadata();
        this.metadataOnChange();
      }
      else {
        this.carregarListagem('ngOnInit');
      }
    }
    else {
      if ( this.controller && this.controller.getFilter ) {
        this.filter = this.controller.getFilter();
      }

      if (this.controller && this.controller.getMetadata) {
        this.lista.cols = this.controller.getMetadata();
        this.metadataOnChange();
      }
    }
  }

  ngAfterViewInit() {
    this.criaSubscriptionInputBuscaRapida();
    this.paginaIniciando = false;
  }

  getBundle(resultset: any, columns: Metadata[], rowIndex: number): IListaBundle {
    const o: IListaBundle = {
      data: {
        resultset: resultset,
        columns: columns,
        rowIndex: rowIndex
      }
    };

    return o;
  }

  getLoading(): boolean {
    return this.loading;
  }

  setLoading(loading: boolean): void {
    setTimeout(() => {
      this.loading = loading;
    }, 0);
  }

  getCarregarListagemSubject(): Subject<Lista> {
    return this.carregarListagemSubject;
  }

  aoMudarPagina(event: LazyLoadEvent): void {
    try {
      if ( !this.carregarOnLoad && this.paginaIniciando ) {
        this.carregarOnLoad = true;
        return;
      }

      const pagina = this.listaUtil.calculaPagina(event);

      if ( this.debug ) { console.log('lista.component : aoMudarPagina'); }

      if ( this.noServiceAndObservable ) {
        return;
      }

      if (!this.controller.getService && !this.controller.getListaObservable) {
      	this.loading = false;
      }

      if ( !this.carregarOnLoad && pagina === 0 ) {

        // nao carregar apenas na abertura da tabela.
        // eh necessario setar TRUE no carregamento on-load pois o usuario pode
        // navegar de volta a pagina 0
        this.carregarOnLoad = true;
        return;
      }

      if (!this.controller) {
        this.toasterService.warning('Controller não encontrado.');
        return;
      }
      else {
        if (this.controller.aoMudarPagina) {
          // TODO: necessario setar this.size, this.totalRegistros aqui para paginacao de listas fora do Default
          // this.controller.aoMudarPagina(event)
                        //  .subscribe(listaPaginacao => {
                        //    if (listaPaginacao) {
                        //      this.size = listaPaginacao.tamanhoPagina;
                        //      this.totalRegistros = listaPaginacao.totalRegistros;
                        //    }
                        //  });
          // return;
        }
      }

      if (!this.controller.getService && !this.controller.getListaObservable) {
        if ( !this.carregarOnLoad && pagina === 0 ) {
          this.toasterService.warning('Service e Observable não encontrados.');
        }
        return;
      }

      if ( this.controller.getFilter ) {
        this.filter = this.controller.getFilter();
      }

      if ( !this.filter ) {
        this.filter = {};
      }

      this.filter.page = pagina;

      this.filter = this.listaUtil.defineOrdenacao(event, this.filter);

      // se nao existir ordenacao é um sinal que pode se tratar da primeira requisição. deve-se verificar se existe ordenação no metadata.
      if ( !this.filter.sort ) {
        this.filter = this.listaUtil.defineOrdenacaoPeloMetadata(this.lista.cols, this.filter);
      }

      let observable: Observable<ListaResultset<any>> = null;

      if (this.controller.getListaObservable) {
        observable = this.controller.getListaObservable(this.filter);
      }

      if ( !observable ) {
        if ( this.controller.getService() ) {
          observable = (this.controller.getService() as DefaultService<any>)
                                       .listar(this.filter);
        }
      }

      if ( observable ) {
        this.loading = true;
        observable.pipe (
                    catchError(err => {
                      this.tratarErroDeCarregamento(err);
                      throw err;
                    })
                    , map (response => {
                      this.size = response['size'];
                      this.totalRegistros = response['totalElements'];
                      this.lista.resultset = response;
                      this.loading = false;

                      this.carregarListagemSubject.next(this.lista);
                    })
                  )
                  .subscribe();
      }
    }
    catch(e) {
      this.hasError = true;
      this.loading = false;

      this.toasterService.error('Ocorreu um erro na operação', e.message);
    }
  }


  criaSubscriptionInputBuscaRapida() {
    if ( !this.inputBuscaRapida || !this.inputBuscaRapida.nativeElement ) {
      return;
    }
    setTimeout(() => {
      this.inputBuscaRapida.nativeElement.focus();
    }, 850);

    const palavra$ = fromEvent<any>(this.inputBuscaRapida.nativeElement, 'keyup')
                    .pipe(
                      map(event => event.target.value),
                      // startWith(''),
                      debounceTime(environment.default_debounce_time),
                      distinctUntilChanged()
                    );
    if (this.subscriptionBuscaRapida) {
      this.subscriptionBuscaRapida.unsubscribe();
    }

    this.subscriptionBuscaRapida = palavra$.subscribe(
        _palavra => {
          if ( this.metadataBuscaRapida ) {
            this.loading = true;

            const nomeDoFiltro = this.metadataBuscaRapida.buscaRapidaFilterName ? this.metadataBuscaRapida.buscaRapidaFilterName
                                                                                : this.metadataBuscaRapida.fieldId;

            if (_palavra) {
              this.filter[nomeDoFiltro] = _palavra;

              if (this.controller.getFilter) {
                this.controller.getFilter()[nomeDoFiltro] = _palavra;
              }
            }
            else {
              delete this.filter[nomeDoFiltro];

              if (this.controller.getFilter) {
                delete this.controller.getFilter()[nomeDoFiltro];
              }
            }

            delete this.filter.page;

            if (this.controller.getFilter) {
              delete this.controller.getFilter()['page'];
            }

            if (this.pCarregarListagem) {
              this.pCarregarListagem();
            }
            else {
                this.carregarListagem('subscriptionListRefresh');
            }
          }
        }
      );
  }


  aoSelecionarLinha(e: IListaBundle, dataKey: any) {
      if ( this.controller ) {
        if ( this.controller.toggleCheckboxLinha ) {
          this.controller.toggleCheckboxLinha(e);
        }
        else if ( this.controller.aoSelecionarLinha ) {
          this.controller.aoSelecionarLinha(e, dataKey);
        }
      }
  }

  tratarErroDeCarregamento(err: any): void {
    this.hasError = true;
    this.loading = false;

    if ( err.status === 403 ) {
      this.errorMsg = 'Acesso negado';
    }
  }

  removerPropriedades(origem: DefaultFilter, destino: DefaultFilter): DefaultFilter {
    Object.keys(origem)
          .forEach(origemKey => {
            if ( origemKey === 'status' ) {
              return;
            }
            for ( const destinoKey in destino ) {
              if ( origemKey === destinoKey ) {
                delete destino[destinoKey];
              }
            }
          });

    return destino;
  }

  mergeFilters(filtroAtual: DefaultFilter, filterController: DefaultFilter): DefaultFilter {
    // propriedades do filtroController substituirão propriedades do filtroAtual caso coexistam.
    let mergedFilters: DefaultFilter;

    if ( filterController && Object.keys(filterController).length > 0 ) {
      mergedFilters = {...filtroAtual, ...filterController};
    }
    else {
      // se o filterController foi limpo, remover as propriedades dele do filtro atual
      mergedFilters = this.removerPropriedades(this.filterControllerAntigo, filtroAtual);
    }

    this.filterControllerAntigo = filterController;

    return mergedFilters;
  }

  carregarListagem(origem?: string) {

    if ( this.debug ) { console.log('lista.component : carregarListagem'); }

    let observable: Observable<ListaResultset<any>>;

    if ( this.controller.getFilter ) {
      const filtroDoController = this.controller.getFilter();
      if ( filtroDoController ) {
        this.filter = this.mergeFilters(this.filter, filtroDoController);
      }
    }

    if (this.controller.getService && this.controller.getService()) {
      observable = (this.controller.getService() as DefaultService<any>).listar(this.filter);
    }
    else if (this.controller.getListaObservable) {
      observable = this.controller.getListaObservable(this.filter);
    }
    else {
      return this.recarregarListagemHack();
    }

    observable .pipe (
                  catchError(err => {
                    this.tratarErroDeCarregamento(err);
                    throw err;
                  })
                  , map (response => {
                    if (response && response.content) {
                      this.size = response['size'];
                      this.totalRegistros = response['totalElements'];
                      this.lista.resultset = response;
                      this.loading = false;
                    }

                    this.carregarListagemSubject.next(this.lista);

                    this.calcularAcumuladores();
                  })
                )
                .subscribe();
    // if (this.controller.getService && this.controller.getService()) {
    //   (this.controller.getService() as DefaultService<any>)
    //   .listar(this.filter)
    //   .pipe (
    //     map (response => {
    //       if (response && response.content) {
    //         this.size = response['size'];
    //         this.totalRegistros = response['totalElements'];
    //         this.lista.resultset = response;
    //         this.loading = false;
    //       }
    //     })
    //   )
    //   .subscribe();
    // }
    // else {
    //   this.recarregarListagemHack();
    // }
  }

  public setListaResultset<T>(listaResultset: ListaResultset<T>): void {
    this.size = listaResultset['size'];
    this.totalRegistros = listaResultset['totalElements'];
    this.lista.resultset = listaResultset;
  }

  // hack para forçar o refresh da PrimeNg TurboTable ( aparentemente um bug no componente )
  public recarregarListagemHack() {

    if ( this.debug ) { console.log('lista.component : recarregarListagemHack'); }

    this.refreshHackFix = false;
    this.changeDetectorRef.detectChanges();

    setTimeout(() => {
          if ( this.controller.getMetadata && this.controller.getMetadata() ) {
            this.lista.cols = this.controller.getMetadata();
          }
          this.refreshHackFix = true;
          this.metadataOnChange();

          this.carregarListagemSubject.next(this.lista);

          // this.changeDetectorRef.detectChanges();
          this.calcularAcumuladores();
      }, 0);
  }

  metadataOnChange() {

    if ( this.debug ) { console.log('lista.component : metadataOnChange'); }

    this.metadataBuscaRapida = this.listaUtil.getCampoComBuscaDoMetadata(this.lista.cols);
    if ( this.metadataBuscaRapida ) {
      this.buscaRapidaNomePlaceholder = `Buscar por ${this.metadataBuscaRapida.fieldName.toLowerCase()}`;

      setTimeout(() => {
        this.criaSubscriptionInputBuscaRapida();
      }, 250);
    }
  }

  public getResultset() {
    return this.lista.resultset;
  }

  public getContent() {
    if ( this.lista && this.lista.resultset ) {
        return this.lista.resultset.content;
    }

    return null;
  }

  public getCols(): Metadata[] {
    if ( this.lista && this.lista.cols ) {
      return this.lista.cols;
  }

  return null;
  }

  ngOnDestroy() {
    if ( this.debug ) { console.log('lista.component : ngOnDestroy'); }

    if (this.subscriptionListRefresh) {
        this.subscriptionListRefresh.unsubscribe();
    }
    if (this.subscriptionParam) {
        this.subscriptionParam.unsubscribe();
    }
    if (this.subscriptionBuscaRapida) {
      this.subscriptionBuscaRapida.unsubscribe();
    }
  }

  calcularAcumuladores() {

    if ( this.debug ) { console.log('lista.component : calcularAcumuladores'); }

    let i = 0;
    for ( const col of this.lista.cols ) {
      if ( col.acumular ) {
        const fieldId = col.fieldId;

        let valorAcumulado = 0;
        for ( const o of this.lista.resultset.content ) {
          const valorAtual = o[fieldId];
          valorAcumulado += valorAtual;
        }

        valorAcumulado = this.resultsetPipeUtil.tratarDadoPeloDataType(col, valorAcumulado, 0, null);

        this.acumuladores[i] = {
          valor: valorAcumulado
        };
      }

      i++;
    }
  }

}

